<template>
  <div>
    <Row :gutter="16" style="padding: 5px;">
      <Col :span="24">
        <Row :gutter="6">
          <Col :span="24" style="text-align: center;">
            <Button type="success" @click="showAdd = true"><Icon type="ios-add-circle" /> 新增</Button>&nbsp;
            <Input v-model="queryStr" placeholder="请输入关键词" @on-change="fetchData" style="width:320px;"></Input>&nbsp;
            <Select v-model="status" placeholder="状态" @on-change="fetchData" clearable style="width: 80px;text-align: left;">
              <Option v-for="(status, key) in sts" :key="key" :value="key"><Icon :type="'ios-' + status.icon" :style="'color:' + status.color"/>{{ status.label }}</Option>
            </Select>&nbsp;
            <!-- <RadioGroup v-model="mode" type="button" >
              <Radio label="card"><Icon type="ios-apps"></Icon> 卡片视图</Radio>
              <Radio label="list"><Icon type="ios-list"></Icon> 列表视图</Radio>
            </RadioGroup> -->
          </Col>
        </Row>
        <!-- <Row v-if="mode === 'card'">
          <Col :span="6" v-for="subject in subjects" :key="subject.usubjectid" style="padding: 3px;">
            <subject-item ref="subjectItem" :model="subject" @refresh="fetchData">
            </subject-item>
          </Col>
        </Row> -->
        <Table stripe :columns="attributes" :data="subjects" v-if="subjects && mode === 'list'">
          <template slot-scope="{ row }" slot="action">
            <Button icon="ios-create" size="small" @click="entry(row.usubjid, 1)" :disabled="row.isReviewer">初录</Button>&nbsp;
            <Button icon="md-copy" size="small" @click="entry(row.usubjid, 2)" :disabled="row.isCreator">二录</Button>
          </template>
          <template slot-scope="{ row }" slot="delete">
            <Icon type="ios-reply" color="#d7d7d7" v-if="row.status === 0"/>
            <Icon type="ios-trash" color="#d7d7d7" v-if="row.status === 1"/>
          </template>
        </Table>
        <pagination v-bind:meta="pageMeta" name="pagination"
        v-if="pageMeta.pageCount > 1" @refresh="fetchData"></pagination>
      </Col>
    </Row>

    <Modal v-model="showAdd" title="新增受试者" :footer-hide="true">
        <add-subject ref="addSubject" @refresh="fetchData"></add-subject>
    </Modal>

  </div>
</template>

<script>
import Pagination from '@/components/share/Pagination'
// import SubjectItem from '@/components/subject/SubjectItem'
import AddSubject from '@/components/subject/AddSubject'
import { ListAllSubjects, GetAssistItems } from '@/api/subject'

export default {
  name: 'subjects',
  data: function () {
    return {
      subjects: [],
      status: '',
      statuses: {},
      siteid: '',
      sites: {},
      queryStr: '',
      pageMeta: {},
      mode: 'list',
      showAdd: false,
      filename: __filename,
      attributes: [
        { title: '研究中心', key: 'siteName', sortable: true },
        { title: '受试者编号', key: 'subjid', width: 120, sortable: true },
        { title: '筛选号', key: 'screenid', width: 120, sortable: true },
        { title: '姓名缩写', key: 'name', width: 120, sortable: true },
        { title: '初录者', key: 'createName', width: 120, sortable: true },
        { title: '状态', key: 'statusText', width: 120, sortable: true },
        { title: '操作', width: 200, slot: 'action' }
      ],
      sts: {
        '1': {
          color: '#19be6b',
          icon: 'checkmark-circle',
          label: '激活'
        },
        '0': {
          color: '#ed4014',
          icon: 'close-circle',
          label: '删除'
        }
      }
    }
  },
  components: {
    'pagination': Pagination,
    // 'subject-item': SubjectItem,
    'add-subject': AddSubject
  },
  created: function () {
    this.fetchData()
    this.getItems()
  },
  methods: {
    fetchData: function () {
      var query = {}
      query['page'] = this.pageMeta.currentPage
      query['queryStr'] = this.queryStr
      query['SubjectSearch[studyid]'] = this.$route.params.id
      query['SubjectSearch[status]'] = this.status
      query['SubjectSearch[siteid]'] = this.siteid
      ListAllSubjects(query).then(async res => {
        this.subjects = res.items
        this.pageMeta = res._meta
      })
      this.showAdd = false
    },
    getItems: function () {
      const studyid = this.$route.params.id
      GetAssistItems(studyid).then(async res => {
        this.statuses = res.statuses
      })
    },
    entry: function (id, batch) {
      const url = '/study/' + this.$route.params.id + '/subject/' + id
      this.$router.push({ path: url, query: { batch: batch } })
    }
  }
}
</script>
